<script setup>
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { themeConfig } from '@themeConfig'

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})
</script>

<template>
  <div class="auth-wrapper d-flex">
    <VCol
      md="4"
      class="d-none d-md-flex align-top justify-center pa-10"
      style="background: linear-gradient(135deg, rgb(var(--v-theme-primary)) 0%, rgb(var(--v-theme-primary-darken-1)) 100%);"
    >
      <div class="text-center text-white">
        <VIcon
          icon="ri-checkbox-circle-line"
          size="120"
          class="mb-8"
        />
        <h2 class="text-h3 font-weight-bold mb-4">
          Check your email
        </h2>
        <p class="text-h6 mb-8">
          Thank you for joining our professional network
        </p>
        <div class="d-flex flex-column gap-4 text-left">
          <div class="d-flex align-center gap-3">
            <VIcon
              icon="ri-check-line"
              size="24"
            />
            <span>Your profile has been created</span>
          </div>
          <div class="d-flex align-center gap-3">
            <VIcon
              icon="ri-check-line"
              size="24"
            />
            <span>Open the secure activation link</span>
          </div>
          <div class="d-flex align-center gap-3">
            <VIcon
              icon="ri-check-line"
              size="24"
            />
            <span>Choose your password and sign in</span>
          </div>
        </div>
      </div>
    </VCol>

    <VCol
      cols="12"
      md="8"
      class="d-flex align-top justify-center"
      style="background-color: rgb(var(--v-theme-surface));"
    >
      <VCard
        flat
        class="registration-card"
        :elevation="0"
      >
        <div class="d-flex align-top justify-center mb-8">
          <RouterLink to="/">
            <div class="d-flex align-center gap-3">
              <VNodeRenderer :nodes="themeConfig.app.logo" />
              <h1 class="text-h4">
                {{ themeConfig.app.title }}
              </h1>
            </div>
          </RouterLink>
        </div>

        <VCard
          class="pa-8 completion-card"
          elevation="0"
        >
          <div class="completion-content">
            <VIcon
              icon="ri-checkbox-circle-line"
              size="56"
              color="success"
              class="mb-4"
            />

            <p class="mb-3 text-h5 font-weight-bold text-center">
              Thank you for your registration
            </p>

            <p class="mb-3 text-body-1 text-medium-emphasis text-center">
              We have sent a secure activation link to your email address.
            </p>

            <p class="mb-3 text-body-1 text-medium-emphasis text-center">
              Use it to confirm your email address and choose your password.
            </p>

            <p class="mb-6 text-body-1 text-medium-emphasis text-center">
              Your account will be activated automatically after confirmation.
            </p>

            <VBtn
              color="primary"
              size="large"
              href="/"
              prepend-icon="ri-home-4-line"
            >
              Back to institutional site
            </VBtn>
          </div>
        </VCard>
      </VCard>
    </VCol>
  </div>
</template>

<style lang="scss" scoped>
.auth-wrapper {
  min-height: 100vh;
}

.registration-card {
  inline-size: 100%;
  max-inline-size: 100%;
}

.completion-card {
  display: flex;
  justify-content: center;
}

.completion-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-inline-size: 38rem;
  margin-inline: auto;
}
</style>
